window._env_ = {
  ENVIRONMENT: 'qas',
  SOLUTION: '',
  VERSION: '1.0',
};

module.exports = window._env_;
